import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

/*
  Generated class for the PostProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class MeetteamProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/lunchroulette';
  
  getAll(): Observable<Response<MeetTeam[]>> {
    return this.http.get<Response<MeetTeam[]>>(this._url + '/list');
  }

  get(id: string): Observable<Response<MeetTeam>> {
    return this.http.get<Response<MeetTeam>>(this._url + `/${id}/show`);
  }

  create(meeting: MeetTeamCreate): Observable<Response<MeetTeam>> {
    return this.http.post<Response<MeetTeam>>(this._url + `/create`, meeting);
  }

  delete(id: string): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._url + `/${id}/delete`, null);
  }

  // Comments
  commentCreate(comment): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._url + `/comment/create`, comment);
  }

  getMetUsers(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._url + '/getmetuser');
  }

}

export interface MeetTeam {
  id: string;
  company_id?: string;
  user_id?: string;
  lunchroulette_id?: string;
  lunchroulette_date?: string;
  count?: number;
  full?: boolean;
  date?: string;
  zoom_url?: string;
  created_at: string;
  updated_at: string;
}

export interface MeetTeamCreate {
  date: string;
  multiple: boolean;
  type: string;
}

export interface commentCreate {
  lunchroulette_id: string;
  content: string;
}


// WEBPACK FOOTER //
// ./src/providers/meetteam/meetteam.ts